<template>
  <div class="game-start">
    <div class="top-bar">
      <div class="logo">
        <img
          src="~/../assets/logo.svg"
          alt="BFGoodrich">
      </div>
    </div>
    <div class="wrapper">
      <h1>Nivel <span :class="{animated:animate}">{{ level }}</span></h1>
      <simon-game
        class="game"
        ref="simon"
        @levelChange="onLevelChange"
        @gameOver="onFinishGame"
        :started="gameStarted"
      />
      <h3>
        <img
          src="~/../assets/stopwatch.svg"
          alt="Cronómetro"> <span>|</span> {{ formattedTime }}</h3>
      <div class="button-wrapper">
        <button
          class="btn btn-primary btn-block"
          v-if="!gameStarted"
          @click="startGame">Comenzar</button>
        <button
          class="btn btn-primary btn-block"
          v-if="!gameStarted"
          @click="$emit('activateInnerView', 'instructions')">Instrucciones</button>
          <!-- <button
          class="btn btn-primary btn-block"
          v-if="gameStarted"
          @click="$emit('activateInnerView', 'instructions')">¡Me rindo!</button> -->
      </div>
    </div>
    <transition enter-active-class="animated zoomInUp">
      <end-game
        :attempts="level"
        :time="formattedTime"
        v-if="gameFinished" />
    </transition>
  </div>

</template>

<script>
import SimonGame from '../components/simon-game.vue'
import moment, { now } from 'moment'
import { setTimeout } from 'timers'
import EndGame from '../components/end-game.vue'

export default {
  components: {
    SimonGame,
    EndGame
  },
  props: {
    games: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      gameStarted: false,
      gameFinished: false,
      startTime: 0,
      currentTime: 0,
      timerInterval: null,
      level: 1,
      animate: false
    }
  },
  computed: {
    formattedTime () {
      return moment(this.currentTime).format('mm:ss:SS')
    }
  },
  methods: {
    startTimer () {
      this.startTime = now()
      this.timerInterval = window.setInterval(this.timerCounter, 97)
    },
    timerCounter () {
      this.currentTime = moment().subtract(this.startTime)
    },
    stopTimer () {
      window.clearInterval(this.timerInterval)
      this.timerInterval = null
    },
    startGame () {
      this.startTimer()
      this.gameStarted = true
      this.$emit('')
      this.$refs.simon.start()
    },
    onFinishGame (score) {
      this.stopTimer()
      this.gameFinished = true
      this.$emit('gameFinished', { score: this.level, time: this.currentTime })
      // TODO: ENVIAR HTTP
    },
    onLevelChange (level) {
      this.animate = true

      setTimeout(() => {
        this.level = level
      }, 250)
      setTimeout(() => {
        this.animate = false
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  color: white;
  font-size: 24px;
  text-align: center;
  font-weight: 400;
  img {
    vertical-align: middle;
    width: 24px;
  }
  span {
    color: #707070;
  }
}

.game-start {
  background-color: #000;
  width: 100vw;
  height: 100vh;
  overflow: auto;
  .top-bar {
    background-color: #fff;
    height: 60px;
    width: 100%;
    .logo {
      height: 40px;
      padding-top: 10px;
      text-align: center;
      img {
        height: 100%;
      }
    }
  }
  .wrapper {
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  h1 {
    color: #fff;
    font-size: 24px;
    text-align: center;
    font-weight: 400;
    text-transform: uppercase;
    span {
      font-weight: 700;
    }
  }
  .game {
    height: 50vh;
    max-height: 80vw;
    width: 50vh;
    max-width: 80vw;
    margin: 0px auto;
  }
  .animated {
    display: inline-block;
    animation: pulse 0.5s ease-out;
  }

  @keyframes pulse {
    0% {
    }
    50% {
      transform: translateY(-10px);
      opacity: 0;
    }
    51% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/simon-game/views/game-start-view.vue